module.exports = __webpack_public_path__ + "img/emptyTree.97102d20.png";